import { Component, Prop } from 'vue-property-decorator';
import { LocationDTO } from "../../../model/LocationDTO";
import { LocationStatsDTO } from '../../../model/LocationStatsDTO';
import { Block } from '../../../helpers/components';
import { SearchPanel } from '../../../components/search-panel/search-panel';
import { BaseBlock } from '../../base-block';

@Block()
@Component({
	components: {
		SearchPanel
	}
})
export class ApartmentLocationSearchBlock extends BaseBlock {
	@Prop() location: LocationDTO;
	@Prop() locationStats: LocationStatsDTO;
}

export default ApartmentLocationSearchBlock;
